import type { ReactElement, ReactNode } from "react";
import { ToastProvider } from "@/components/ui/toast/toastContext";

type AppProvidersProps = {
  children: ReactNode;
};

export function AppProviders({ children }: AppProvidersProps): ReactElement {
  return (
    <ToastProvider>
      <div data-testid="app-providers" style={{ display: "contents" }}>
        {children}
      </div>
    </ToastProvider>
  );
}
